import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconLocation = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <circle cx="12" cy="9.99888" r="3.42857" stroke="currentColor" strokeWidth="1.5" />
      <path d="M20 10C20 16.8571 13 21.4286 12 21.4286C11 21.4286 4 16.2857 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconLocation
